import { Controller } from '@hotwired/stimulus';

/** Zero-dependency confetti: fixed canvas, tiny particle loop (~2KB logic vs npm bundle). */
function fireConfetti(originX, originY) {
  const colors = [
    '#dc2626',
    '#ef4444',
    '#f87171',
    '#fca5a5',
    '#fbbf24',
    '#fb7185',
    '#fda4af',
    '#fecaca',
    '#fef08a',
    '#ffffff',
  ];

  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  Object.assign(canvas.style, {
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '9999',
  });

  const cssW = window.innerWidth;
  const cssH = window.innerHeight;
  const dpr = window.devicePixelRatio || 1;
  canvas.width = cssW * dpr;
  canvas.height = cssH * dpr;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);

  const count = 78;
  const particles = [];
  for (let i = 0; i < count; i++) {
    const spread = (Math.random() - 0.5) * 1.35;
    const angle = -Math.PI / 2 + spread;
    const speed = 9 + Math.random() * 16;
    particles.push({
      x: originX,
      y: originY,
      vx: Math.cos(angle) * speed * (0.55 + Math.random() * 0.9),
      vy: Math.sin(angle) * speed,
      w: 3 + Math.random() * 5,
      h: 5 + Math.random() * 6,
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.4,
      color: colors[(Math.random() * colors.length) | 0],
      drag: 0.988,
    });
  }

  const gravity = 0.42;
  let frame = 0;
  const maxFrames = 95;

  function step() {
    frame++;
    ctx.clearRect(0, 0, cssW, cssH);

    let alive = false;
    for (const p of particles) {
      p.vy += gravity;
      p.vx *= p.drag;
      p.vy *= p.drag;
      p.x += p.vx;
      p.y += p.vy;
      p.rot += p.vr;

      if (p.y < cssH + 24 && p.x > -24 && p.x < cssW + 24) {
        alive = true;
      }

      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      ctx.globalAlpha = Math.max(0, 1 - frame / maxFrames);
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }

    if (alive && frame < maxFrames) {
      requestAnimationFrame(step);
    } else {
      canvas.remove();
    }
  }

  requestAnimationFrame(step);
}

export default class extends Controller {
  burst(event) {
    const button = event.currentTarget;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const rect = button.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;
    const originY = rect.top + rect.height / 2;

    fireConfetti(originX, originY);

    button.classList.add('love-vote--popped');
    window.setTimeout(() => button.classList.remove('love-vote--popped'), 420);
  }
}
